<template>
  <div :class="[$style.wrapper, $style[`wrapper--${routeScope}`]]">
    <div v-show="availableScopes.length" :class="$style.search">
      <!--
        search.scope_term.SERVICE
        search.scope_term.BIKES
        search.scope_term.ARCHIVE
        search.scope_term.ALL
        search.scope_term.PART_SALE
      -->
      <v-text-field
        v-model="searchText"
        :class="$style.searchinput"
        color="primary"
        :label="$t(`search${!routeScope ? '.term' : `.scope_term.${routeScope}`}`)"
        flat
        outlined
        dense
        single-line
        hide-details
        autocomplete="off"
        @keyup.enter="setTextSearchQuery"
      >
        <template #append>
          <v-btn
            v-show="searchText"
            color="primary"
            icon
            small
            :height="36"
            :width="36"
            :elevation="0"
            @click="clearTextSearchQuery"
          >
            <v-icon medium>mdi-close-circle</v-icon>
          </v-btn>
          <v-btn
            color="primary"
            icon
            small
            :height="36"
            :width="36"
            :elevation="0"
            @click="setTextSearchQuery"
          >
            <v-icon large>mdi-magnify</v-icon>
          </v-btn>
        </template>
      </v-text-field>
    </div>
  </div>
</template>

<script>
import { get, isUndefined, head } from 'lodash-es'
import { mapActions } from 'vuex'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import SEARCH_ACTIONS from '@/js/plugins/store/modules/search/action-types.js'
import FILTER_CONSTANTS from '@/js/helper/filter-constants.js'
import PermissionMixin from '@/js/mixins/permission-mixin.js'

export default {
  name: 'NavigationProductSearchbar',
  mixins: [PermissionMixin],
  data() {
    return {
      searchText: '',
    }
  },
  computed: {
    searchQuery() {
      const path = `state.${STOREMODULES.SEARCH}.${FILTER_CONSTANTS.TYPE.SEARCH_TEXT}`
      return get(this.$store, path)
    },
    routeScope() {
      const scope = get(this.$route, ['meta', 'scope'])
      return isUndefined(scope) || scope === '' ? undefined : scope
    },
    isSearchRoute() {
      return this.$route.meta.isSearchList
    },
    availableScopes() {
      return this.getAvailableScopes()
    },
  },
  watch: {
    searchQuery: {
      handler() {
        if (this.searchQuery !== this.searchText) {
          this.searchText = get(this.searchQuery, 0, '')
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(STOREMODULES.SEARCH, {
      setSearchQuery: SEARCH_ACTIONS.SET_SEARCH_QUERY,
    }),
    setTextSearchQuery() {
      this.setSearchQuery(this.searchText)
      if (!this.isSearchRoute) {
        const targetScope = this.routeScope || head(this.availableScopes)
        console.log(`Not a searchroute, route to ${targetScope}`)
        this.$router.push({ name: targetScope })
      }
    },
    clearTextSearchQuery() {
      this.searchText = ''
      this.setSearchQuery(this.searchText)
    },
  },
}
</script>

<style lang="scss" module>
.wrapper {
  display: flex;

  color: var(--primary);
}

.search {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  :global(.v-application) & :global(.elevation-0) {
    box-shadow: none !important;
  }
}

.searchinput {
  :global(.v-input__slot) {
    padding-right: 0;
  }

  :global(.v-input__append-inner) {
    margin-top: 0.2rem !important;
  }

  :global(a.v-btn) {
    text-decoration: none !important;
  }
}
</style>
